export const hideFooterRoutes = [
  "login",
  "register",
  "forgot-password",
  "reset-password",
  "change-password",
  "chat",
];

export const hideHeaderRoutes = [
  "login",
  "register",
  "forgot-password",
  "reset-password",
  "change-password",
];

export const cookieNames = {
  accessToken: "access_token",
  refreshToken: "refresh_token",
  userInfo: "user_info",
  interactedArtworks: "interacted_artworks_ids",
}